import {NEW_ID} from '../../../common/constants/index.js'
import {showUpgradeModal} from '../../Modals/UpgradeModal.js'
import {useSelector} from '../../../store.js'
import {userCountSelector} from '../../../data/users.js'
import {maxUserCountSelector} from '../../../data/company.js'
import {Count, Plural, PluralBlock} from '../../../common/components/Plural.js'
import FormList from '../Common/FormList.js'
import FormListItem from '../Common/FormListItem.js'
import TextInput from '../Common/TextInput.js'
import {
  saveUser,
  settingsUserAddSelector,
  updateUsersForm,
  userSettingsErrorsSelector,
  usersFormSelector,
} from './usersFunctions.js'
import ButtonPrimary from '../../../common/components/Button/ButtonPrimary.js'
import LinkButton from '../../../common/components/Link/LinkButton.js'
import {USER_SETTINGS_LINK} from '../../../common/constants/SettingsPanels.js'
import Icon from '../../../common/icons/Icon.js'

export default function NewForm() {
  const form = useSelector(usersFormSelector)
  const errors = useSelector(userSettingsErrorsSelector)
  const isNew = useSelector(settingsUserAddSelector)
  const userCount = useSelector(userCountSelector)
  const maxUserCount = useSelector(maxUserCountSelector)

  const canHaveMoreUsers = userCount < maxUserCount

  return (
    <li className="settings-list-item add-item clearfix expanded">
      <div className="medium-12 columns button-wrap">
        {canHaveMoreUsers ? (
          <p>
            <a
              href={`#/settings/user/${NEW_ID}`}
              title="Add a user"
              className="inline-text-button no-underline"
            >
              <Icon name="sym-add" className="fs-01 margin-right-5" />
              <span>Add a user</span>
            </a>
          </p>
        ) : (
          <div className="margin-top-15 align-center">
            <p className="margin-bottom-10">
              <strong>
                <PluralBlock count={maxUserCount}>
                  Want to add more than <Count options={{toEnglish: true}} />{' '}
                  <Plural word="user" />?
                </PluralBlock>
              </strong>
            </p>
            <button
              className="btn btn--primary btn--primary-alt btn--md fs-01"
              onClick={() => showUpgradeModal()}
            >
              <strong>Upgrade Your Plan</strong>
            </button>
          </div>
        )}
      </div>
      {isNew && canHaveMoreUsers && (
        <form className="settings-list-item-form-wrap padding-bottom-10 clear-both">
          <fieldset>
            {errors.serverError && (
              <div className="row">
                <ul className="medium-5 columns error-list">
                  <li>{errors.serverError}</li>
                </ul>
              </div>
            )}

            <FormList className="medium-5 columns margin-left-0">
              <FormListItem className="bigger margin-bottom-20">
                <TextInput
                  label="Name"
                  required
                  name="user_name"
                  value={form.name || ''}
                  onChange={(event) =>
                    updateUsersForm({
                      name: event.target.value,
                      hasChanged__name: true,
                    })
                  }
                  errorMessage={form.hasChanged__name && errors.name}
                />
              </FormListItem>
              <FormListItem className="bigger margin-bottom-20">
                <TextInput
                  label="Email"
                  required
                  name="user_email"
                  value={form.email || ''}
                  onChange={(event) =>
                    updateUsersForm({
                      email: event.target.value,
                      hasChanged__email: true,
                    })
                  }
                  errorMessage={form.hasChanged__email && errors.email}
                />
              </FormListItem>
              {!errors.preventSave && (
                <li className="list__item list__item--no-style margin-bottom-20">
                  <div className="alert alert--standard">
                    <span className="fs-n0 lh-sm">
                      After you create this user, an email will be sent to them
                      with instructions for setting a password for their
                      account.
                    </span>
                  </div>
                </li>
              )}

              <li className="list__item list__item--no-style">
                <ButtonPrimary
                  isDisabled={errors.preventSave}
                  isLoading={form.isSaving}
                  onClick={saveUser}
                >
                  Create New User
                </ButtonPrimary>
                <LinkButton href={USER_SETTINGS_LINK} mode="secondary">
                  Cancel
                </LinkButton>
              </li>
            </FormList>
          </fieldset>
        </form>
      )}
    </li>
  )
}
